type Slot = 'LEFT' | 'RIGHT' | 'TOP' | 'BOTTOM'

const NUMTICKS = 5

export const legendAutoLayout = (slot?: Slot) => {
  return (helper) => {

    const lastSize = helper.getLastSize()
    const aspectRatio = helper.getLastAspectRatio()

    const xAxisAdjust = (lastSize[0] / 700) ** 0.8
    const yAxisAdjust = (lastSize[1] / 300) ** 0.8
    const minAdjust = Math.min(xAxisAdjust, yAxisAdjust)

    const axisTextStyle = helper.getAxisTextStyle()
    const tickTextStyle = helper.getTickTextStyle()

    const fontSize = Math.max(10 * minAdjust, 5)
    axisTextStyle.fontSize = fontSize

    if (aspectRatio > 1.0) {
      tickTextStyle.fontSize = fontSize
    } else {
      tickTextStyle.fontSize = fontSize
    }

    // rebuild the text atlas
    const textSizes = helper.updateTextureAtlas()

    // helper.setTopTitle(false)
  
    const boxSize = helper.getBoxSizeByReference()

    let titleWidth, titleHeight, tickWidth, tickHeight

    if (slot === 'RIGHT' || slot === 'LEFT') {
      helper.setTickLabelPixelOffset(0.4 * tickTextStyle.fontSize)
      helper.setAxisTitlePixelOffset(0.8 * axisTextStyle.fontSize)

      titleWidth = (2.0 * (Math.max(textSizes.titleHeight, 8) + helper.getAxisTitlePixelOffset())) / lastSize[0]
      tickWidth = (2.0 * (textSizes.tickWidth + helper.getTickLabelPixelOffset())) / lastSize[0]

      boxSize[0] = tickWidth + 1.4 * titleWidth    
      boxSize[1] = Math.max(1.2, Math.min(1.84 / yAxisAdjust, 1.84))

    } else if (slot === 'TOP' || slot === 'BOTTOM') {
      helper.setAxisTitlePixelOffset(1.25 * tickTextStyle.fontSize)
      helper.setTickLabelPixelOffset(-1.75 * tickTextStyle.fontSize)

      titleHeight = (2.0 * (Math.max(textSizes.titleHeight, 8) + helper.getAxisTitlePixelOffset())) / lastSize[1]
      tickWidth = (2.0 * textSizes.tickWidth) / lastSize[0]
      tickHeight = (2.0 * (textSizes.tickHeight + helper.getTickLabelPixelOffset())) / lastSize[1]

      boxSize[0] = Math.min(
        1.9,
        Math.max(1.4, 1.4 * tickWidth * (helper.getTicks().length + 3))
      )
      
      boxSize[1] = tickHeight + titleHeight
    }

    if ((!slot && aspectRatio > 1.0) || slot === 'RIGHT') {

      helper.setBoxPosition([0.99 - boxSize[0], -0.7])

    } else if ((!slot && aspectRatio <= 1.0) || slot === 'BOTTOM') {

      helper.setBoxPosition([-0.5 * boxSize[0], -0.85])

    } else if (slot === 'LEFT') {

      helper.setBoxPosition([boxSize[0] - 1.125, -0.7])

    } else if (slot === 'TOP') {

      helper.setBoxPosition([-0.5 * boxSize[0], 0.6])
    }

    helper.recomputeBarSegments(textSizes)
  }
}

export const generateTicks = (dictionary: Object) => {
  return (helper) => {
    const numTicks = dictionary 
      ? Object.values(dictionary)?.length
      : NUMTICKS - 1
    const lastTickBounds = helper.getLastTickBounds()
    const range = lastTickBounds[1] - lastTickBounds[0]
    const ticks = [...Array.from(Array(numTicks).keys()), numTicks].map(
      (tick) => (tick / numTicks) * range + lastTickBounds[0]
    )

    const precision = range < 5 ? range < 1 ? 2 : 1 : 0

    const format = (num) => num.toFixed(precision)
    helper.setTicks(ticks)

    let tickStrings = ticks.map(format)
    
    // If there is ordinal_dictionary
    if (dictionary) {
      const indexes = ticks.map((str) => parseInt(str))
      tickStrings = Object.values(dictionary)
        .filter((_, index) => indexes.includes(index))
    }

    helper.setTickStrings(tickStrings)
  }
}
